import { useBlogEditorReadOnlyPlugin } from '@doltech/ui/lib/figma/BlogEditor/hooks/useBlogEditorReadOnlyPlugin';
import { PluginPresetEnum } from '@doltech/ui/lib/figma/BlogEditor/BlogEditor.types';
import {
  ParagraphToggleReadOnlyPlugin,
} from '@doltech/ui/lib/figma/BlogEditor/plugins-common/ParagraphToggle/ParagraphToggleReadOnlyPlugin';
import { EditorExerciseBlankPlugin } from '@doltech/ui/lib/editor-save-data/blank-plugin/EditorExerciseBlankPlugin';

export const useBlogEditorReadOnlyGrammarPlugin = (props?) => {
  const { onBackWhenInComplete } = props || {};
  const { plugins, preprocessReadOnlyInitialValues } =
    useBlogEditorReadOnlyPlugin({
      presets: [
        PluginPresetEnum.HEADING,
        PluginPresetEnum.TEXT_FORMAT,
        PluginPresetEnum.BLOCK_FORMAT,
        PluginPresetEnum.HTML_OBJECT,
        PluginPresetEnum.MEDIA_OBJECT,
        PluginPresetEnum.DIVIDER,
        PluginPresetEnum.SPECIAL_OBJECT,
        PluginPresetEnum.CORE_PARAGRAPH_AT_END,
      ],
      onBackWhenInComplete,
    });

  return {
    plugins: [
      ...plugins,
      EditorExerciseBlankPlugin({ isReadOnly: true }),
      ParagraphToggleReadOnlyPlugin({ isReadOnly: true }),
      // ExplanationsPlugin({ isReadOnly: true }),
    ],
    preprocessReadOnlyInitialValues,
  };
};
